import { AbstractControl, ValidationErrors } from '@angular/forms';
import { HandlingTypeEnum } from '../models/enums/handling-type.enum';
import { MeasureUnitEnum } from '../models/vehicle.model';

export const PalletMinLDM = function (modalForm: AbstractControl): ValidationErrors | null {
  const width = modalForm.get('width')?.value;
  const length = modalForm.get('length')?.value;
  const unit = modalForm.get('lengthUnit')?.value;
  if (modalForm.get('handlingType')?.value === HandlingTypeEnum.PALLET) {
    const q = unit === MeasureUnitEnum.METER ? 1 : 100;
    if (width && length && (+width * +length) / q < 0.1) {
      return { invalidLoadingMeter: true };
    }
  }
  return null;
};
